import { Pipe, PipeTransform } from '@angular/core';
import { combineLatest, isObservable, Observable, of } from 'rxjs';
import { GridsterItem } from 'angular-gridster2';
import { BrickInstancesSelectors } from '../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { Store } from '@ngxs/store';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import _ from 'lodash';

@Pipe({
   name: 'brickIdToGridsterConfig$',
})
export class BrickIdToGridsterConfigPipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(brickInstanceId: Observable<string> | string, isBrickEditPossible: boolean = true): Observable<GridsterItem> {
      let brickInstanceId$: Observable<string>;

      if (isObservable(brickInstanceId)) {
         brickInstanceId$ = brickInstanceId;
      } else {
         brickInstanceId$ = of(brickInstanceId);
      }

      return combineLatest([brickInstanceId$, this.store.select(BrickInstancesSelectors.gridsterItemForBrickInstanceFn)]).pipe(
         switchMap(([instanceId, gridsterItemForBrickInstanceFn]) =>
            of(gridsterItemForBrickInstanceFn(instanceId, isBrickEditPossible)).pipe(
               distinctUntilChanged(),
               map((x) => _.cloneDeep(x))
            )
         )
      );
   }
}
